var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
var viewInMobile = windowWidth < 768;
var evaluateRunningInApp = function evaluateRunningInApp() {
  return sessionStorage.getItem('runningInApp') === 'true' || sessionStorage.getItem('app.settings.login') === 'sso' || sessionStorage.getItem('mm_app') !== null;
};
var runningInApp = evaluateRunningInApp();
var isIos = sessionStorage.getItem('mm_app') === 'vsios' || ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
var androidRedirectUrl = 'https://app.verisure.com';
var applicationRedirectUrl = 'https://app.verisure.com';
var iosAppBaseUrl = 'vsbridge://';
var androidAppBaseUrl = 'verisure://';
var SMS_TOKEN_LENGTH = 6;
var KEY_TAG_PIN_CODE_LENGTH = 4;
var MAX_USERS = 9;
var DEFAULT_POLL_TIMEOUT = 180000;
var INPUT_FIELD_DEFAULT_MIN_LENGTH = 1;
var PHONE_MIN_LENGTH = 5;
var PHONE_MAX_LENGTH = 15;
var DEVICE_AREA_MIN_LENGTH = 1;
var DEVICE_AREA_MAX_LENGTH = 30;
var ALIAS_MIN_LENGTH = 1;
var ALIAS_MAX_LENGTH = 50;
var NAME_MIN_LENGTH = 1;
var NAME_MAX_LENGTH = 40;
var FIRST_NAME_MAX_LENGTH = 25;
var LAST_NAME_MAX_LENGTH = 25;
var EMAIL_MIN_LENGTH = 6;
var EMAIL_MAX_LENGTH = 254;
var PASSWORD_MIN_LENGTH = 1;
var PASSWORD_MAX_LENGTH = 30;
var STREET_NAME_LENGTH = 40;
var ZIP_NUMBER_LENGTH = 10;
var CITY_NAME_LENGTH = 30;
var CO_LENGTH = 40;
var CODE_WORD_MIN_LENGTH = 4;
var CODE_WORD_MAX_LENGTH = 20;
var CODE_WORD_MAX_WORDS = 2;
var GOOGLE_MAPS_API_URL = 'https://maps.googleapis.com/maps/api';
var GOOGLE_MAPS_STATIC_MAP_URL = "".concat(GOOGLE_MAPS_API_URL, "/staticmap");
var GOOGLE_MAPS_API_KEY = 'AIzaSyC87Giqku3KHfWs8WxTFnuNagcdwAP_XCg';
var QS_DEVICELABEL = 'deviceLabel';
var QS_OPENPANEL = 'action';
var QS_SIDEPANEL = 'sidePanel';
var QS_CONTACTID = 'contactId';
var BLACKLIST_ERROR_LOG_SERVER = ['localhost', 'local.verisure.com', 'local-mypages.verisure.com',
// 'galactica-mypages.dev.verisure.com',
'caprica-mypages.dev.verisure.com', 'mypages.sys.verisure.com'];
var ALLOWED_ERROR_LOG_SERVER = ['mypages.verisure.com', 'galactica-mypages.dev.verisure.com' // remove after successfull test
];

var getAdobeImageUrlWithSuffix = function getAdobeImageUrlWithSuffix(size, url) {
  var fileFormat = 'png'; // Surl.split('.').pop();
  switch (size) {
    case 'small':
      return "".concat(url, "/jcr:content/renditions/small-152.").concat(fileFormat);
    case 'medium':
      return "".concat(url, "/jcr:content/renditions/medium-240.").concat(fileFormat);
    case 'large':
      return "".concat(url, "/jcr:content/renditions/large-600.").concat(fileFormat);
    default:
      return "".concat(url, "/jcr:content/renditions/medium-240.").concat(fileFormat);
  }
};
var listCountryWithoutVoice = ['FI'];

export { ALIAS_MAX_LENGTH, ALIAS_MIN_LENGTH, ALLOWED_ERROR_LOG_SERVER, BLACKLIST_ERROR_LOG_SERVER, CITY_NAME_LENGTH, CODE_WORD_MAX_LENGTH, CODE_WORD_MAX_WORDS, CODE_WORD_MIN_LENGTH, CO_LENGTH, DEFAULT_POLL_TIMEOUT, DEVICE_AREA_MAX_LENGTH, DEVICE_AREA_MIN_LENGTH, EMAIL_MAX_LENGTH, EMAIL_MIN_LENGTH, FIRST_NAME_MAX_LENGTH, GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_API_URL, GOOGLE_MAPS_STATIC_MAP_URL, INPUT_FIELD_DEFAULT_MIN_LENGTH, KEY_TAG_PIN_CODE_LENGTH, LAST_NAME_MAX_LENGTH, MAX_USERS, NAME_MAX_LENGTH, NAME_MIN_LENGTH, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, PHONE_MAX_LENGTH, PHONE_MIN_LENGTH, QS_CONTACTID, QS_DEVICELABEL, QS_OPENPANEL, QS_SIDEPANEL, SMS_TOKEN_LENGTH, STREET_NAME_LENGTH, ZIP_NUMBER_LENGTH, androidAppBaseUrl, androidRedirectUrl, applicationRedirectUrl, evaluateRunningInApp, getAdobeImageUrlWithSuffix, iosAppBaseUrl, isIos, listCountryWithoutVoice, runningInApp, viewInMobile };
